/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Claim } from '@wsphere/warranties/domain';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-item-cure-card',
  templateUrl: './claim-item-cure-card.component.html',
  standalone: false,
})
export class ClaimItemCureCardComponent {
  @Input() item: Claim.ClaimItem.Model | null = null;
}
